import { useQuery } from '@tanstack/react-query';
import http from '../../../utils/http';

export function useGetSingleProviderDetails({providerId}: {providerId: string}) {
  const { data, ...rest } = useQuery({
    queryKey: ['single provider details', providerId || null  ],
    queryFn: async () => {
      const response = await http.get(`appointments/patient/${providerId}`);            
      return response.data?.patientsAppointment ?? {};
    },
    enabled: !!providerId
  });

  return {
    singleAppointment: data  ?? {},
    ...rest,
  };
} 
